var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-table',{ref:"historyList",attrs:{"endpoint":_vm.endpoint,"route-context":"settings.businessunit.sync"},on:{"action":_vm.doAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }